import { render } from "./reRegister.vue?vue&type=template&id=1f13df24&scoped=true"
import script from "./reRegister.vue?vue&type=script&lang=js"
export * from "./reRegister.vue?vue&type=script&lang=js"

import "./reRegister.vue?vue&type=style&index=0&id=1f13df24&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f13df24"]])

export default __exports__